import { ContentBlock, GuideTypes, Metadata, WizardStepLink } from "../models";
import { Entry } from "contentful";
import { convertToHtmlString, extractContent, findContent } from "../utils";
import { FieldMapping, UserContextValues } from "../types";

export const createWizardStepLink = (
  fieldMapping: FieldMapping<WizardStepLink>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): WizardStepLink | undefined => {
  const text = findContent(entries, fieldMapping.text, guideType);
  const callback = findContent(entries, fieldMapping.callback, guideType);
  const isSubstep = fieldMapping.isSubstep as unknown as boolean;

  const parsedCallback = extractContent(convertToHtmlString(callback?.fields.richContent, userContextValues) || "")
  const parsedText = convertToHtmlString(text?.fields.richContent, userContextValues);
  return parsedText 
  ? {
    text: parsedText,
    callback: parsedCallback || "",
    isSubstep: isSubstep
  } 
  : undefined;
};
